import { ChangeDetectionStrategy, Component } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, FiscalYear, Permission, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherFormComponent } from "src/app/backoffice/acc/accvoucher/accvoucher-form/accvoucher-form.component";
import { ReviewService } from "src/app/review/review.service";
import { InvVoucherFormComponent } from "../../invvoucher/invvoucher-form/invvoucher-form.component";

@Component({
  selector: "purchase-invoice-report",
  templateUrl: "purchase-invoice-report.component.html",
  styleUrls: ["purchase-invoice-report.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PurchaseInvoiceReportComponent extends BaseListComponent {
  actions: EntityListAction[];
  formGroup: UntypedFormGroup;
  GetInvVoucherKindColumns: form_control[] = [];
  GetDetailLedgerColumns: form_control[] = [];
  GetWarehouseColumns: form_control[] = [];
  GetGoodsGroupColumns: form_control[] = [];
  GetGoodsColumns: form_control[] = [];
  GetGoodsCardAmountColumns: form_control[] = [];
  GetGoodsCardPriceColumns: form_control[] = [];
  GetPurchaseInvoiceReport: form_control[] = [];
  GetVoucherDetailColumns: form_control[] = [];
  GetGoodsFormulaColumns: form_control[] = [];
  GetProductConsumptionReport: form_control[] = [];
  InvVoucherKindIds: number[] = [];
  StatusKindIds: number[] = [];
  BranchIds: number[] = [];
  WarehouseIds: number[] = [];
  DetailLedgerIds: number[] = [];
  ReferenceVoucherKindIds: number[] = [];
  activeTabTitle: string;
  selected: string = "";
  constructor(private service: ReviewService, private tabsservice: TabularService, private fb: UntypedFormBuilder) {
    super();
    this.onActionClick = this.onActionClick.bind(this);
  }

  ngOnInit(): void {
    this.service.startDate = new Date();
    this.service.endDate = new Date();
    let currentFiscalYear = this.accountService.authService.currentFiscalYear;

    this.setactions();
    if (currentFiscalYear) {
      this.service.startDate.setDate(this.service.startDate.getDate() - 30);
      this.service.startDate$.next(this.service.startDate);
      this.service.startDate$.next(this.service.startDate);
      if (currentFiscalYear && currentFiscalYear.StartDate) {
        let fystartDate = new Date(currentFiscalYear.StartDate);
        if (fystartDate.setHours(0, 0, 0, 0) > this.service.startDate.setHours(0, 0, 0, 0))
          this.service.startDate = this.accountService.authService.currentFiscalYear.StartDate;
        else if (fystartDate.setHours(0, 0, 0, 0) < this.service.startDate.setHours(0, 0, 0, 0)) {
          this.service.startDate = currentFiscalYear.StartDate;
          this.service.endDate = currentFiscalYear.EndDate;
          this.service.startDate$.next(currentFiscalYear.StartDate);
          this.service.endDate$.next(currentFiscalYear.EndDate);
        }
      }
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x: FiscalYear) => {
        if (x && x.StartDate) {
          this.service.startDate.setDate(this.service.startDate.getDate() - 30);
          let fystartDate = new Date(x.StartDate);
          if (fystartDate.setHours(0, 0, 0, 0) > this.service.startDate.setHours(0, 0, 0, 0)) this.service.startDate = x.StartDate;
          else if (fystartDate.setHours(0, 0, 0, 0) < this.service.startDate.setHours(0, 0, 0, 0)) {
            this.service.startDate = x.StartDate;
            this.service.endDate = x.EndDate;
            this.service.startDate$.next(currentFiscalYear.StartDate);
            this.service.endDate$.next(currentFiscalYear.EndDate);
          }
        }
      });
    this.formGroup = this.fb.group({
      InvVoucherKindIds: this.InvVoucherKindIds,
      StatusKindIds: this.StatusKindIds,
      BranchIds: this.BranchIds,
      WarehouseIds: this.WarehouseIds,
      DetailLedgerIds: this.DetailLedgerIds,
      ReferenceVoucherKindIds: this.ReferenceVoucherKindIds,
      OnlySupplier: false,
      IsGoods: false,
      SlaveNo: undefined,
      StartNumber: undefined,
      EndNumber: undefined,
      IsService: false,
      TraceElement: undefined,
      ReceiptDate: undefined,
      ShowBeginingOfTheCoursResidue: false,
      ShowRunningTotal: false,
    });
    this.service.filter$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x) {
        let ShowBeforeRemain: boolean = x.items.some((r) => r.key === "ShowBeforeRemain");
        let AmountRemain: boolean = x.items.some((r) => r.key === "ShowRunningTotal");
        if (AmountRemain) {
          this.GetVoucherDetailColumns.find((x) => x.name === "AmountRemain").listVisible = true;
        }
        this.populateGridColumns();
      }
    });
    this.populateGridColumns();
    this.setColumns();
  }
  setColumns() {
    this.httpCommonService
      .get("InventoryReview/GetGoodsFormulaInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.GetGoodsFormulaColumns = data as form_control[];
            this.GetGoodsFormulaColumns = this.GetGoodsFormulaColumns.sort((a, b) => a.order - b.order);
            this.GetGoodsFormulaColumns.find((x) => x.name === "BranchCode").listVisible = true;
            this.GetGoodsFormulaColumns.find((x) => x.name === "BranchTitle").listVisible = true;
            this.GetGoodsFormulaColumns.find((x) => x.name === "ProductCode").listVisible = true;
            this.GetGoodsFormulaColumns.find((x) => x.name === "ProductName").listVisible = true;
            this.GetGoodsFormulaColumns.find((x) => x.name === "ProductUnitTitle").listVisible = true;
            this.GetGoodsFormulaColumns.find((x) => x.name === "ProductShamsiEffectDate").listVisible = true;

            this.setColumnVisiblty();
          }
        },
        (error) => console.log(error)
      );

    this.httpCommonService
      .get("InventoryReview/GetInventoryReviewInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.GetVoucherDetailColumns = data as form_control[];
            this.GetVoucherDetailColumns = this.GetVoucherDetailColumns.sort((a, b) => a.order - b.order);
            this.GetVoucherDetailColumns.forEach((x) => {
              if (
                x.name === "BranchCode" ||
                x.name === "BranchTitle" ||
                x.name === "VoucherDate" ||
                x.name === "ReceiptDate" ||
                x.name === "ShamsiReceiptDate" ||
                x.name === "SlaveNo" ||
                x.name === "GoodsMainUnitTitle" ||
                x.name === "DetailLedgerCode" ||
                x.name === "WarehouseCode" ||
                x.name === "GoodsGroupCode" ||
                x.name === "GoodsGroupTitle" ||
                x.name === "AmountRemain" ||
                x.name === "MonthAmount" ||
                x.name === "Amount" ||
                x.name === "MainAmount" ||
                x.name === "DaylyAvrage" ||
                x.name === "MonthlyAvrage"
              )
                x.listVisible = false;
              if (x.name === "Amount" || x.name === "MainAmount") x.listVisible = true;
            });
            this.setColumnVisiblty();
          }
        },
        (error) => console.log(error)
      );
  }
  setColumnVisiblty() {}
  populateGridColumns(): any {
    var col: form_control[] = [];
    col = [
      {
        name: "DiscountAmount",
        modelName: "DiscountAmount",
        listVisible: true,
        label: "تخفیف",
        order: 9,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Surplusage",
        modelName: "Surplusage",
        listVisible: true,
        label: "اضافات",
        order: 10,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Deduction",
        modelName: "Deduction",
        listVisible: true,
        label: "کسورات",
        order: 11,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Tax",
        modelName: "Tax",
        listVisible: true,
        label: "مالیات",
        order: 12,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: false,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
    this.GetPurchaseInvoiceReport = [];
    Object.assign(this.GetPurchaseInvoiceReport, col);
    this.GetPurchaseInvoiceReport.push({
      name: "WarehouseTitle",
      modelName: "WarehouseTitle",
      listVisible: true,
      label: "َانبار",
      order: 1,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "DetailLedgerTitle",
      modelName: "DetailLedgerTitle",
      listVisible: true,
      label: "تامین کننده",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "InvVoucherKindTitle",
      modelName: "InvVoucherKindTitle",
      listVisible: true,
      label: "نوع سند",
      order: 2,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "VoucherNo",
      modelName: "VoucherNo",
      listVisible: true,
      label: "شماره سند",
      order: 3,
      textType: "number",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "ShamsiVoucherDate",
      modelName: "ShamsiVoucherDate",
      listVisible: true,
      label: "تاریخ سند",
      order: 4,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "GoodsTitle",
      modelName: "GoodsTitle",
      listVisible: true,
      label: "َکالا",
      order: 5,
      textType: "text",
      withComma: false,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "Amount",
      modelName: "Amount",
      listVisible: true,
      label: "تعداد",
      order: 6,
      textType: "number",
      withComma: true,
      isDecimal: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "UnitPrice",
      modelName: "UnitPrice",
      listVisible: true,
      label: "فی خرید",
      order: 7,
      textType: "number",
      withComma: true,
      isDecimal: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "Price",
      modelName: "Price",
      listVisible: true,
      label: "مبلغ خرید",
      order: 8,
      textType: "number",
      withComma: true,
      isDecimal: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "MaxUnitPrice",
      modelName: "MaxUnitPrice",
      listVisible: true,
      label: "بیشترین مبلغ خرید",
      order: 8,
      textType: "number",
      withComma: true,
      isDecimal: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "AverageUnitPrice",
      modelName: "AverageUnitPrice",
      listVisible: true,
      label: "میانگین مبلغ خرید",
      order: 8,
      textType: "number",
      withComma: true,
      isDecimal: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "InvoiceTotal",
      modelName: "InvoiceTotal",
      listVisible: true,
      label: "جمع فاکتور",
      order: 13,
      textType: "number",
      withComma: true,
      isDecimal: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "LastUnitPrice",
      modelName: "LastUnitPrice",
      listVisible: true,
      label: "آخرین فی خرید",
      order: 14,
      textType: "number",
      withComma: true,
      isDecimal: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport.push({
      name: "MinUnitPrice",
      modelName: "MinUnitPrice",
      listVisible: true,
      label: "کمترین فی خرید",
      order: 15,
      textType: "number",
      withComma: true,
      isDecimal: true,
      formVisible: false,
      disabled: false,
      areaName: null,
      systemName: undefined,
      category: undefined,
      DetailControlModels: undefined,
    });
    this.GetPurchaseInvoiceReport = this.GetPurchaseInvoiceReport.sort((a, b) => a.order - b.order);
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }
  onActionClick(action: EntityListAction, onRowSelected: any, onRowsSelected: any[], isAllSelected: boolean, gridFilter: GridFilter[]) {
    ///نمایش سند حسابداری
    if (action.name === "AccVoucherHeader") {
      var datatrasfer: Datatransfer = <Datatransfer>{};
      onRowSelected.Id = onRowSelected.AccVoucherHeaderId;
      datatrasfer.apiName = action.apiName;
      datatrasfer.areaName = action.areaName;
      datatrasfer.currentrow = onRowSelected;
      action.Form_Component = AccVoucherFormComponent;
      datatrasfer.apiName = "AccVoucherHeader";
      datatrasfer.areaName = "Accounting";
      datatrasfer.label = "سند حسابداری";
      if (onRowSelected.AccVoucherHeaderId) this.showVoucher(datatrasfer, action);
    }

    ///سند مبنا
    if (action.name === "BaseVoucher") {
      var datatrasfer: Datatransfer = <Datatransfer>{};
      onRowSelected.Id = onRowSelected.VoucherHeaderId;
      datatrasfer.apiName = action.apiName;
      datatrasfer.areaName = action.areaName;
      datatrasfer.currentrow = onRowSelected;
      action.Form_Component = InvVoucherFormComponent;
      datatrasfer.apiName = action.apiName;
      datatrasfer.areaName = action.areaName;
      datatrasfer.label = "سند انبار";
      if (onRowSelected.VoucherHeaderId) this.showVoucher(datatrasfer, action);
    }
  }
  showVoucher(datatrasfer: Datatransfer, action: any) {
    const menu = <ITab>{
      title: datatrasfer.label,
      isCloseable: true,
      icon: action.iconName,
      active: true,
      responsive: true,
      componentType: action.Form_Component,
      data: [
        { provide: EntityBase, useValue: datatrasfer.currentrow },
        { provide: Datatransfer, useValue: datatrasfer },
        { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: 0 } },
      ],
    };
    this.tabsservice.open(menu);
  }
  setactions() {
    this.actions = [
      {
        name: "AccVoucherHeader",
        disabled: false,
        isModal: false,
        displayName: "سند حسابداری",
        iconName: "icon-table_view-f",
        Form_Component: AccVoucherFormComponent,
        apiName: "AccVoucherHeader",
        areaName: "Accounting",
        permission: Permission.viewPermission,
      },
      {
        name: "BaseVoucher",
        disabled: false,
        isModal: false,
        displayName: "سند مبنا",
        iconName: "icon-folder-open-outline",
        areaName: "Inventory",
        Form_Component: InvVoucherFormComponent,
        apiName: "InvVoucherHeader",
        permission: Permission.viewPermission,
      },
      {
        name: "GetGoodsHistory",
        disabled: false,
        displayName: "تاریخچه",
        iconName: "icon-history-o",
        areaName: "Inventory",
        Form_Component: InvVoucherFormComponent,
        apiName: "InventoryReview/GetGoodsHistory",
        permission: Permission.samePermission,
      },
    ];
  }
  setSelectedFilter(filter: string) {
    if (this.selected === filter) this.selected = "";
    else this.selected = filter;
  }
}
